import { render, staticRenderFns } from "./Selbstauskunft.vue?vue&type=template&id=7d6cfc38&scoped=true&"
import script from "./Selbstauskunft.vue?vue&type=script&lang=js&"
export * from "./Selbstauskunft.vue?vue&type=script&lang=js&"
import style0 from "./Selbstauskunft.vue?vue&type=style&index=0&id=7d6cfc38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6cfc38",
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage})
